import { render, staticRenderFns } from "./contract-liquid-vimo.vue?vue&type=template&id=696c2c42&scoped=true"
import script from "./contract-liquid-vimo.vue?vue&type=script&lang=js"
export * from "./contract-liquid-vimo.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=696c2c42&prod&scoped=true&lang=css&external"
import style1 from "./contract-liquid-vimo.vue?vue&type=style&index=1&id=696c2c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c2c42",
  null
  
)

export default component.exports